import React from "react";
import CommunityEditPage from "../community/components/CommunityEditPage";
import { IMMEDIATE_HELP } from "../community/constants";
import { useRequireSectionVisible } from "../../client/hooks/useRequireSectionVisible";

export default function EditImmediateHelpPage() {
  useRequireSectionVisible("showUrgentHelp");
  return <CommunityEditPage section={IMMEDIATE_HELP} />;
}
